package org.multiplatform.kotfolio.pages.java

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/java/abstract_class")
@Composable
fun AbstractClassJavaPage() {
    BlogLayout(
        PageProperties(
            "Abstract class",
            ""),
        BlogProperties("Java", "Abstract class")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Abstraction",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstraction is a process of hiding the implementation details and showing only functionality to the user.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Another way, it shows only important things to the user and hides the internal details.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstraction lets you focus on what the object does instead of how it does it.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Ways to achieve Abstraction",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are two ways to achieve abstraction in Java.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Abstract class (0 to 100%)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Interface (100%)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Abstraction Advantage",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "By using abstraction, we can separate the things that can be grouped to another type.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Frequently changing properties and methods can be grouped to a separate type so that the main type need not undergo changes. This adds strength to the OOAD principle -\"Code should be open for Extension but closed for Modification",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Abstract class Use",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Java Abstract classes are used to declare common characteristics of subclasses.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we have only static member in our class which can able be accessed with its class name so no need of creating object unnecessarily. So for restricting user to create an object declare that class as abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is used to when the user want to have their own implementation. So declaring a method as abstract will give a chance to an user to have their own implementation for same method name.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Abstract class and method rules",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Variable cannot be made abstract, its only behavior or methods which would be abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If a class extends an abstract class or interface it has to provide implementation to all its abstract method to be a concrete class. Alternatively this class can also be abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class may also have concrete (complete) methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "For design purpose, a class can be declared abstract even if it does not contain any abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Reference of an abstract class can point to objects of its sub-classes thereby achieving run-time polymorphism Ex: Shape obj = new Rectangle();",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A class must be compulsorily labeled abstract, if it has one or more abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A class that is declared as abstract is known as abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class is a class which contains one or more abstract methods, which has to be implemented by sub classes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class can contain no abstract methods also i.e. abstract class may contain concrete methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract methods must be declared using abstract key word and class must be declared using abstract key word.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract method must be in abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract methods do not have body (No Implement).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class definition begins with the keyword “abstract” keyword followed by Class definition.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract classes are useful in a situation when some general methods should be implemented and specialization behavior should be implemented by subclasses.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class can contain private as well as protected members.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A class extending an abstract class need not implement any of the methods defined in the abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The bodies of these methods are omitted.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract class must be extended by at least one subclass.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The subclass of abstract class must override all abstract methods of super class or it must be declared as abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All the abstract methods must be overridden.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class cannot be instantiated; they must be sub classed, and actual implementations must be provided for the abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class is a class in which one or more methods are declared, but not defined.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You can only go back one level.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the constructor, if you use super(), it must be the very first code, and you cannot access any this.xxx variables or methods to compute its parameters.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Any child class must either override the abstract method or declare itself abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class is a class with zero or more abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class contains instance variables & concrete methods in addition to abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is not possible to create objects to abstract class. But we can create a reference of abstract class type.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All the abstract methods of the abstract class should be implemented in its sub classes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If any method is not implemented, then that sub class should be declared as ‘abstract’.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class reference can be used to refer to the objects of its sub classes. Abstract class references cannot refer to the individual methods of sub classes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A class cannot be both ‘abstract’ & ‘final’.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It cannot be instantiate means we cannot create object of an abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class can have instance member.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract class doesn't have any method implementation instead can have only method declaration.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We cannot make an inner class as abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We cannot use static method but can use static variable in the abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Extending abstract class means we need to override the abstract methods defined in the abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If we don't want to override abstract in its sub-class then declare that sub-class as abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract class may or may not have an abstract method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Constructor of the abstract class will be used to instantiate the abstract class instance variable.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Overridden abstract class methods will be accessed by its sub-class object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We can be able to create and reference variable for an abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All functions in java by default virtual.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An abstract method is a method whose implementation is deferred to a subclass.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Abstract class syntax",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    abstract class <class_name>
                    {
                    	............................
                    	............................
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    public class ClassHierarchy
                    {
                        static class Base
                        {
                            public Base()
                            {
                                System.out.println("Base");
                                init();
                            }

                            public void init()
                            {
                                System.out.println("Base:init");
                            }
                        }

                        static class Derived extends Base
                        {
                            int a = 0;

                            public Derived()
                            {
                                System.out.println("Derived");
                                init();
                            }

                            public void init()
                            {
                                if (a == 0)
                                {
                                    System.out.println("Derived:init");
                                }
                                a = 1;
                            }
                        }
                        
                        public static void main(String[] args)
                        {
                            new Derived();
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Abstract method",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A method that is declared as abstract and does not have implementation is known as abstract method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    abstract return_type <method_name> (); //no braces { }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    abstract class Bike
                    {
                        abstract void run(); //abstract method
                    }

                    class Honda extends Bike
                    {
                        void run()
                        {
                            System.out.println("Running safely ....");
                        }
                    }

                    class First
                    {
                        public static void main(String args[])
                        {
                            Bike obj = new Honda(); // Reference using object create
                            obj.run();
                        }
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A class that contains at least one abstract method and therefore can never be instantiated.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract classes are created so that other classes can inherit them and implement their abstract methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sometimes, a class that you define represents an abstract concept and as such, should not be instantiated.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are situations in which you will want to define a super class that declares the structure of a given abstraction without providing a complete implementation of every method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "That is, sometimes you will want to create a super class that only defines generalized form that will be shared by all its subclasses, leaving it to each subclass to fill in the details.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Such a class determines the nature of the methods that the subclasses must implement. One way this situation can occur is when a super class is unable to create a meaningful implementation for a method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You can require that certain methods be overridden by subclasses by specifying the abstract type modifier.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These methods are sometimes referred to as sub classer responsibility because they have no implementation specified in the super class. Thus, a subclass must override them - it cannot simply use the version defined in the super class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To declare an abstract method, use the general form:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        abstract type name (parameter - list);
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Any class that contains one or more abstract methods must also be declared abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To declare a class abstract, you simply use the abstract keyword in front of the class keyword at the beginning of the class declaration.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The class which has abstract methods must be declared as abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    abstract class Bike
                    {
                        abstract void run();
                    }

                    class Honda extends Bike
                    {
                        void run()
                        {
                            System.out.println("Running safely ....");
                        }
                    }

                    class First
                    {
                        public static void main(String args[])
                        {
                            Bike obj = new Bike()
                            {
                                @Override
                                void run()
                                {
                                    System.out.println("Running safely 1 ....");
                                }
                            };
                            obj.run();
                        }
                    }
                    """.trimIndent()
                )
            }

            SpanText(
                text = "There are some rules for abstract class and methods",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract methods must be in abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract methods do not have body. (No implementation)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There can be no objects of an abstract class. That is, an abstract class cannot be directly instantiated with the new operator. Such objects would be useless, because an abstract class is not fully defined. Also, you cannot declare abstract constructors, or abstract static methods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The abstract class must be extended by at least one subclass.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The subclass of abstract class must override all abstract methods of super class or it must be declared as abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "All the abstract methods must be overridden.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Any subclass of an abstract class must either implement all of the abstract methods in the super class or be itself declared abstract.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    abstract class A
                    {
                        abstract void call();
                    }

                    class B extends A
                    {
                        void call()
                        {
                            System.out.println("A class implement ");
                        }
                    }

                    class First
                    {
                        public static void main(String[] a)
                        {
                            B ob = new B();
                            ob.call();
                        }
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Notice that no objects of class A are declared in the program. As mentioned, it is not possible to instantiate an abstract class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Once other point: class A implements a concrete method called callmetoo(). This is perfectly acceptable.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abstract classes can include as much implementation as they see fit.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Although abstract classes cannot be used to instantiate objects, they can be used to create object references, because java's approach to run - time polymorphism is implemented through the use of super class references.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Thus, it must be possible to create a reference to an abstract class so that it can be used to point to a sub class object. You will see this feature put to use in the next example.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Using an abstract class, you can improve the Figure class show earlier, since there is not meaningful concept of area for an undefined two - dimensional figure, the following version of the program declares area() as abstract inside Figure.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    abstract class Figure
                    {
                        double dim1, dim2;
                        Figure(double a, double b)
                        {
                            dim1 = a;
                            dim2 = b;
                        }
                        abstract double area(); // area is now an abstract method
                    }
                    class Rectangle extends Figure
                    {
                        Rectangle(double a, double b)
                        {
                            super(a, b);
                        }
                        double area() //override area for rectangle
                        {
                            System.out.println("Inside area for Rectangle.");
                            return dim1 * dim2;
                        }
                    }
                    class Triangle extends Figure
                    {
                        Triangle(double a, double b)
                        {
                            super(a, b);
                        }

                        double area() //override area for right triangle     
                        {
                            System.out.println("Inside area for Triangle.");
                            return dim1 * dim2 / 2;
                        }
                    }

                    class AbstractAreas {
                        public static void main(String[] args) {
                            //Figure f = new Figure(10,10) // illegal now
                            Rectangle r = new Rectangle(9, 5);
                            Triangle t = new Triangle(10, 8);
                            Figure figref;
                            figref = r;
                            System.out.println("Area is" + figref.area());
                            figref = t;
                            System.out.println("Area is" + figref.area());
                        }
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "As the comment inside main() indicates, it is no longer possible to declare objects of type figure, since it is now abstract. And all sub classes of figure must override area().",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To prove this to yourself, try creating a sub class that does not override area(). You will receive a compile - time error.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Although it is not possible to create an object of type Figure, you can create a reference variable of type Figure. The variable figref is declared as reference to Figure. As explained, it is through super class reference variables that overridden methods are resolved at run time.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                    abstract class A
                    {
                        void displaya()
                        {
                            System.out.println("This is a concreate method");
                        }
                        abstract void displayb();
                    }

                    class B extends A
                    {
                        void displayb()
                        {
                            System.out.println("B's implementation");
                        }
                    }
                    class First
                    {
                        public static void main(String[] args)
                        {
                            B b = new B();
                            b.displayb();
                            b.displaya();
                        }
                    }
                    """.trimIndent()
                )

                SpanText(
                    text = "Understanding the real scenario of abstract class",
                    modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "In this example, Shape is the abstract class, its implementation is provided by the Rectangle and Circle classes.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Mostly, we don't know about the implementation class (i.e. hidden to the end user) and object of the implementation class is provided by the factory method.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "A factory method is the method that returns the instance of the class. We will learn about the factory method later.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "In this example, if you create the instance of Rectangle class, draw method of Rectangle class will be invoked.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                KotlinCode(
                    code = """
                    abstract class Shape
                    {
                        abstract void draw();
                    }

                    class Rectangle extends Shape
                    {
                        void draw()
                        {
                            System.out.println("Drawing rectangle");
                        }
                    }

                    class Circle extends Shape
                    {
                        void draw()
                        {
                            System.out.println("Drawing circle");
                        }
                    }

                    class First
                    {
                        public static void main(String[] args)
                        {
                            Shape s = new Circle();
                            //In real scenario, Object is provided through factory method
                            s.draw();
                        }
                    }
                    """.trimIndent()
                )

                SpanText(
                    text = "An abstract class can have data member, abstract method, method body, constructor and even main() method.",
                    modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                        .fontWeight(FontWeight.Bold)
                )

                KotlinCode(
                    code = """
                    //Abstract class that have method body
                    
                    abstract class Bike
                    {
                        abstract void run();
                        void changeGear()
                        {
                            System.out.println("Gear changed");
                        }
                    }

                    class Honda extends Bike
                    {
                        void run()
                        {
                            System.out.println("Running safely .......");
                        }

                        public static void main(String[] args)
                        {
                            Bike obj = new Honda();
                            obj.run();
                            obj.changeGear();
                        }
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    //Abstract class having constructor, field and method
                    
                    abstract class Bike
                    {
                        int limit = 30;
                        Bike()
                        {
                            System.out.println("Constructor is invoked");
                        }
                        void getDetails()
                        {
                            System.out.println("It has two wheels");
                        }
                        abstract void run();
                    }

                    class Honda extends Bike
                    {
                        void run()
                        {
                            System.out.println("Running safely ...");
                        }

                        public static void main(String args[])
                        {
                            Bike obj = new Honda();
                            obj.run();
                            obj.getDetails();
                            System.out.println(obj.limit);
                        }
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    abstract class Shape
                    {
                        double height, weight, width;
                        
                        Shape(double height, double width)
                        {
                            this.height = height;
                            this.weight = width;
                        }
                        abstract double area();
                    }

                    class Rectangle extends Shape
                    {
                        Rectangle(double w, double h)
                        {
                            super(w,h);
                        }
                        double area()
                        {
                            return width * height;
                        }
                    }

                    class Triangle extends Shape
                    {
                        Triangle(double base, double height)
                        {
                            super(base, height);
                        }
                        double area()
                        {
                            return 0.5 * height * width;
                        }
                    }

                    class AbstractDemo
                    {
                        public static void main(String[] args)
                        {
                            Shape ref; //Creating reference of superclass
                            Rectangle r = new Rectangle(10, 15);
                            ref = r;
                            System.out.println("Area of Rectangle :" + ref.area());
                            Triangle t = new Triangle(15, 20);
                            ref = t;
                            System.out.println("Area of Triangle :" + ref.area());
                        }
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    //The abstract class can also be used to provide some implementation of the interface. In such case, the end user may not be forced to override all the methods of the interface.
                        
                    interface A
                    {
                        void a();
                        void b();
                        void c();
                        void d();
                    }
                    
                    abstract class B implements A
                    {
                        public void c()
                        {
                            System.out.println(" I am C");
                        }
                    }
                    
                    class M extends B
                    {
                        public void a()
                        {
                            System.out.println("I am a");
                        }
                        public void b()
                        {
                            System.out.println("I am b");
                        }
                        public void d()
                        {
                            System.out.println("I am d");
                        }
                    }
                    
                    class Test
                    {
                        public static void main(String args[])
                        {
                            A a = new M();
                            a.a();
                            a.b();
                            a.c();
                            a.d();
                        }
                    }
                    """.trimIndent()
                )

                SpanText(
                    text = "Why is this Market-Relevant?",
                    modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                        .fontWeight(FontWeight.Bold)
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Abstract class PaymentProcessor defines common logic (validateAmount) an a mandatory contract (processPayment).",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Subclasses (CreditCardPaymentProcessor, PixPaymentProcessor) implement specific business rules.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "This pattern mirrors real enterprise systems, where payments are diverse but share validation steps.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                KotlinCode(
                    code = """
                        public static abstract class PaymentProcessor {
                            //Concrete method: shared logic 
                            public void validateAmount(double amount) {
                                if(amount <= 0) {
                                    throw new IllegalArgumentException("Amount must be greater than zero.")
                                }
                                System.out.println("Amount validated: " + amount)
                            }
                            
                            //Abstract method: Each payment type must implement its own logic
                            public abstract void processPayment(double amount);
                        }
                        
                        public static class CreditCardPaymentProcessor extends PaymentProcessor {}
                        
                        public static class CreditCardPaymentProcessor extends PaymentProcessor {}
                         
                        //PIX (Instant Trasfer in Brazil)
                        public static class PixPaymentProcessor extends PaymentProcessor {}
                    """.trimIndent()
                )
            }
        }
    }
}